import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Icon,
  Image,
  Input,
  SimpleGrid,
  Stack,
  Text,
  useColorModeValue,
  useToast,
} from "@chakra-ui/react";

// import CoursesModal from "./components/course/CoursesModal";
//import TestModal from "./components/test/TestModal";
import { CheckIcon } from "@chakra-ui/icons";
import { apiurl } from "APIURL";
import axios from "axios";
import Card from "components/card/Card";
import React, { useEffect, useState } from "react";
import { MdUpload } from "react-icons/md";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getAddAnswerData } from "redux/slices/addAnswerSlice";
import { getAddCourseData } from "redux/slices/AddCourseSlice";
import { getAddRessourceData } from "redux/slices/addRessourceSlice";
import { getAddTestData } from "redux/slices/AddTestSlice";
import { getQuestions } from "redux/slices/questionsSlice";
import {
  selectUpdateFormationData,
  setDescription,
  setImage,
  setLoading,
  setPrice,
  setTest,
  setTitle,
} from "redux/slices/updateFormationSlice";
import { getProfileData } from "redux/slices/userSlice";
import Dropzone from "views/admin/profile/components/Dropzone";
import UpdateCourseModal from "./components/course/UpdateCourseModal";
import UpdateTestModal from "./components/test/UpdateTestModal";

export default function Settings() {
  const [id, setId] = useState(0);
  const { title, description, image, price, loading, error, ...rest } =
    useAppSelector(selectUpdateFormationData);
  console.log({ title, description, image, price, loading, error });
  const dispatch = useAppDispatch();

  const profile = useAppSelector(getProfileData);
  const courses = useAppSelector(getAddCourseData).courses;
  const tests = useAppSelector(getAddTestData).tests;
  const initialQuestions = useAppSelector(getQuestions).questions.filter(
    (item) => item.testId === rest.test.id
  );
  const answers = useAppSelector(getAddAnswerData).answers;
  const fileUrl = useAppSelector(getAddRessourceData).fileUrl;
  const toast = useToast();
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const brandColor = useColorModeValue("brand.500", "white");
  const textColorSecondary = "gray.400";
  const formationToUpdate = useAppSelector(
    selectUpdateFormationData
  ).formationToUpdate;
  const [fileInputState, setFileInputState] = useState("");
  const [previewSource, setPreviewSource] = useState(image);
  const [selectedFile, setSelectedFile] = useState();
  const [successMsg, setSuccessMsg] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [disabled, setDisabled] = useState(false);

  const updateTestSubmitHandler = async (e: React.FormEvent) => {
    try {
      const { id, ...data } = rest.test;
      const updateTestResponse = await axios.patch(
        `${apiurl}/test/${id}`,
        data
      );
      console.log(updateTestResponse.data);
      toast({
        title: "Test modifié avec succés",
        status: "success",
      });
    } catch (err) {
      toast({
        title: "Erreur de modification de test",
        status: "error",
      });
    }
  };
  const handleFileInputChange = React.useCallback((acceptedFiles: any) => {
    console.log("changing");
    /*const file = files.target.files[0];
          previewFile(file);
          setSelectedFile(file);
          setFileInputState(files.target.value);*/
    previewFile(acceptedFiles[0]);
    setSelectedFile(acceptedFiles[0]);
    setFileInputState(acceptedFiles[0]);
    acceptedFiles.forEach((file: any) => {
      const reader = new FileReader();

      reader.onabort = () => console.log("file reading was aborted");
      reader.onerror = () => console.log("file reading has failed");
      reader.onload = () => {
        // Do whatever you want with the file contents
        const binaryStr = reader.result;
        console.log(binaryStr);
      };
      reader.readAsArrayBuffer(file);
    });
  }, []);

  const previewFile = (file: any) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setPreviewSource(reader.result);
    };
  };

  const handleSubmitFile = () => {
    //e.preventDefault();
    if (!selectedFile) return;
    const reader = new FileReader();
    reader.readAsDataURL(selectedFile);
    reader.onloadend = () => {
      uploadImage(selectedFile);
    };
    reader.onerror = () => {
      console.error("AHHHHHHHH!!");
      setErrMsg("something went wrong!");
    };
    setDisabled(true);
  };

  const uploadImage = async (file: File) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      for (var key of formData.entries()) {
        console.log(key[0] + ", " + new Object(key[1]));
      }

      const response = await axios.post(apiurl + "/file/upload", formData);
      console.log(response.data);
      dispatch(setImage(response.data));

      setFileInputState("");
      setPreviewSource("");
      setSuccessMsg("Image uploaded successfully");
    } catch (err) {
      console.error(err);
      setErrMsg("Something went wrong!");
    }
  };
  const updateFormationSubmitHandler = async (
    e: React.FormEvent,
    id: number
  ) => {
    e.preventDefault();
    try {
      const res = await axios.patch(`${apiurl}/formation/${id}`, {
        title: title,
        description: description,
        stagiarePrice: parseFloat(price),
        professionalPrice: parseFloat(price) + 20,
        image,
      });
      console.log(res.data);
      dispatch(setLoading(false));
      toast({
        title: "modifié avec succés",
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top",
      });
    } catch (err) {
      toast({
        title: "Erreur de modification",
        description: error,
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top",
      });
    }
  };
  useEffect(() => {
    const setInputs = async () => {
      dispatch(setTitle(rest.formationToUpdate.title));
      dispatch(setDescription(rest.formationToUpdate.description));
      dispatch(setPrice(rest.formationToUpdate.stagiarePrice.toString()));
      dispatch(setImage(rest.formationToUpdate.image));
      const testResponse = await axios.get(
        `${apiurl}/test/formation/${rest.formationToUpdate.id}`
      );
      dispatch(setTest(testResponse.data));
      console.log(rest.test);
    };
    setInputs();
  }, []);

  // Chakra Color Mode
  return (
    <form
      action=""
      onSubmit={(e) => updateFormationSubmitHandler(e, formationToUpdate.id)}
    >
      <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
        <SimpleGrid
          mb="20px"
          columns={{ sm: 1, md: 2 }}
          spacing={{ base: "20px", xl: "20px" }}
        >
          <FormControl id="email">
            <FormLabel>Nom de formation</FormLabel>
            <Input
              value={title}
              onChange={(e) => dispatch(setTitle(e.target.value))}
              borderRadius={"full"}
              type="text"
            />
          </FormControl>
          <FormControl id="email">
            <FormLabel>Description</FormLabel>
            <Input
              value={description}
              onChange={(e) => dispatch(setDescription(e.target.value))}
              borderRadius={"full"}
              type="text"
            />
          </FormControl>
          <FormControl id="email">
            <FormLabel>Prix (DT)</FormLabel>
            <Input
              value={price}
              onChange={(e) => dispatch(setPrice(e.target.value))}
              borderRadius={"full"}
              type="number"
            />
          </FormControl>

          <FormControl id="email">
            <FormLabel>Image</FormLabel>
            <Card mb="20px" alignItems="center" p="20px">
              <Flex h="100%" direction={{ base: "column", "2xl": "row" }}>
                <Dropzone
                  onDrop={handleFileInputChange}
                  w={{ base: "100%", "2xl": "268px" }}
                  me="36px"
                  maxH={{ base: "60%", lg: "50%", "2xl": "100%" }}
                  minH={{ base: "60%", lg: "50%", "2xl": "100%" }}
                  content={
                    <Box>
                      <Icon
                        as={MdUpload}
                        w="80px"
                        h="80px"
                        color={brandColor}
                      />
                      <Flex justify="center" mx="auto" mb="12px">
                        <Text fontSize="xl" fontWeight="700" color={brandColor}>
                          Choisir image
                        </Text>
                      </Flex>
                      <Text
                        fontSize="sm"
                        fontWeight="500"
                        color="secondaryGray.500"
                      >
                        PNG, JPG et GIF sont autorisés
                      </Text>
                    </Box>
                  }
                  value={fileInputState}
                />
                <Flex direction="column" pe="44px">
                  {previewSource ? (
                    <Image src={previewSource} />
                  ) : (
                    <>
                      <Text
                        color={textColorPrimary}
                        fontWeight="bold"
                        textAlign="start"
                        fontSize="2xl"
                        mt={{ base: "20px", "2xl": "50px" }}
                      >
                        Choisir une image comme thumbnail pour votre formation
                      </Text>
                      <Text
                        color={textColorSecondary}
                        fontSize="md"
                        my={{ base: "auto", "2xl": "10px" }}
                        mx="auto"
                        textAlign="start"
                      ></Text>
                    </>
                  )}
                  <Flex w="100%">
                    <Button
                      onClick={handleSubmitFile}
                      me="100%"
                      mb="50px"
                      w="140px"
                      minW="140px"
                      variant="brand"
                      mt={{ base: "20px", "2xl": "auto" }}
                      fontWeight="500"
                    >
                      Publier maintenant
                    </Button>
                  </Flex>
                </Flex>
              </Flex>
            </Card>
          </FormControl>
          <Stack my={5} direction="row" spacing={"auto"}>
            <UpdateTestModal
              submitHandler={updateTestSubmitHandler}
              testId={0}
              setTestId={function (value: React.SetStateAction<number>): void {
                throw new Error("Function not implemented.");
              }}
            />
            <UpdateCourseModal
              formationId={formationToUpdate.id}
              submitHandler={function (e: React.FormEvent<Element>): void {
                throw new Error("Function not implemented.");
              }}
              courseId={0}
              setCourseId={function (
                value: React.SetStateAction<number>
              ): void {
                throw new Error("Function not implemented.");
              }}
            />
            <Button
              leftIcon={<CheckIcon />}
              type="submit"
              colorScheme={"brand"}
            >
              Valider
            </Button>
          </Stack>
        </SimpleGrid>
      </Box>
    </form>
  );
}
